<template>
    <div :class="$x.right">
        <ns-select
            v-if="markets"
            v-model="marketSelection"
            class="flex-column"
            name="countrySelect"
            :items="markets"
            :label="t.market"
            :rules="nameRule"
            @input="marketChanged"
        ></ns-select>
        <v-form ref="addressForm">
            <v-text-field
                v-if="f.addressName.show"
                v-model.trim="addressName"
                name="addressName"
                :maxlength="f.addressName.maxLength"
                :required="f.addressName.required"
                :rules="f.addressName.required ? nameRule : []"
                :disabled="disableAddressName"
                validate-on-blur
                :label="t.addressName"
                class="flex-column"
                @input="fieldUpdated"
            ></v-text-field>
            <ns-address
                v-model="address"
                :lang="language"
                :country="marketSelection.toUpperCase()"
                :include-email="includeEmail"
                :email-required="emailRequired"
                @new-address-in-form="validateNewAddress"
            ></ns-address>
            <ns-phone-number-lib
                v-if="f.phone.show"
                :number="mobilePhone"
                name="mobilePhone"
                :country="mobilePhoneCountry || country"
                :label="t.mobilePhoneLabel || t.phoneLabel"
                class="flex-column"
                @input="phoneUpdated"
                :invalid-message="t.invalidPhone"
                :error-message="t.fieldRequired"
            ></ns-phone-number-lib>
            <v-text-field
                v-if="f.instructions.show"
                v-model.trim="instructions"
                name="instructions"
                :maxlength="f.instructions.maxLength"
                :label="t.instructionsLabel"
                :rules="f.instructions.required ? nameRule : []"
                class="flex-column"
                @input="fieldUpdated"
            ></v-text-field>
        </v-form>
    </div>
</template>

<script>
    import { VTextField } from 'vuetify/lib';
    import { NsAddress } from '@nuskin/smart-common-components';
    import { NsSelect, NsPhoneNumberLib } from '@nuskin/design-components';
    import { fields } from './marketSettings';
    import { shippingAddressStrings } from './demoData';
    import { RunConfigService } from "@nuskin/ns-util";

    export default {
        name: "NsShippingAddressForm",

        components: {
            NsAddress,
            NsSelect,
            VTextField,
            NsPhoneNumberLib
        },

        props: {
            value: {
                type: Object,
                default() {
                    return {}
                }
            },
            language: {
                type: String,
                required: true
            },
            country: {
                type: String,
                required: true
            },
            disableAddressName: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            t: {
                type: Object,
                default() {
                    return shippingAddressStrings;
                }
            }
        },

        data() {
            return {
                address: {...this.value},
                addressName: this.value.addressName,
                editing: this.value.id !== 0,
                f: {
                    ...fields.DEFAULT,
                    ...fields[this.country]
                },
                instructions: this.value.instructions,
                markets: null,
                marketSelection: this.country ? this.country.toLowerCase() : '',
                mobilePhone: this.value.mobilePhone || this.value.phone,
                mobilePhoneCountry: this.value.mobilePhoneCountry || this.value.phoneCountry || this.country,
                nameRule: [],
                validateForm: false
            }
        },

        computed: {
            includeEmail() {
                let showEmail = false;
                if (this.f && this.f.email) {
                    showEmail = this.f.email.show;
                }
                return showEmail;
            },
            emailRequired() {
                let emailRequired = false;
                if (this.f && this.f.email) {
                    emailRequired = this.f.email.required;
                }
                return emailRequired;
            }
        },

        methods: {
            validateNewAddress() {
                this.fieldUpdated();
            },
            phoneUpdated(value) {
                if (value && value.number) {
                    this.mobilePhone = value.number;
                    this.mobilePhoneCountry = value.country;
                    this.fieldUpdated();
                }
            },
            fieldUpdated() {
                this.$emit("input", {
                    ...this.address,
                    addressName: this.addressName,
                    instructions: this.instructions,
                    mobilePhone: this.mobilePhone,
                    mobilePhoneCountry: this.mobilePhoneCountry
                });
            },

            setMarketSelection(formCountry = "us") {
                this.marketSelection = this.country
                    ? this.country.toLowerCase()
                    : formCountry.toLowerCase();
            },

            marketChanged() {
                this.validateForm = false;
                this.$refs.addressForm.resetValidation();
                if (this.address.country === this.marketSelection.toUpperCase()) {
                    this.formAddress = { ...this.address, showFormOnValidate: true };
                } else {
                    this.formAddress = { country: this.marketSelection.toUpperCase() };
                }
            },

            emitEditingAddress(editing) {
                this.$emit("editing", editing);
            },

            reset() {
                this.$refs.addressForm.reset();
            },

            initRules() {
                const requiredRule = (v) => {
                    return (!!v && !!v.trim()) || this.t.fieldRequired;
                };
                const illegalCharactersRule = (v) => {
                    const illegalRegex = this.f.addressName.allowedCharacters;
                    const validation = !v || illegalRegex.test(v.trim()) || this.t.illegalCharacters;
                    return validation;
                }
                this.nameRule = [requiredRule, illegalCharactersRule];
            },

            validate() {
                return this.$refs.addressForm.validate();
            }
    },

        mounted() {
            this.initRules();
            this.markets = fields[RunConfigService.getRunConfig().country].countryList;
        }
    }
</script>

<style lang="scss" module="$x">
    @use "./addressSelector.module.scss";
    //TODO a temp fix for a weird issue. removing it start throwing error while unit test.
    .dummy {
    color: blue;
    }

    .sub-header {
        img {
            margin-right: 10px;
        }
    }
</style>
